import { motion } from "framer-motion";
function StatusLights() {
    return (
        <div className="space-y-2">
        <h4 className="font-semibold text-blue-400 tracking-wider uppercase">
          Status
        </h4>
        <div className="flex items-center space-x-2">
          <motion.div
            className="h-3 w-3 rounded-full bg-green-400"
            animate={{ scale: [1, 1.2, 1] }}
            transition={{ repeat: Infinity, duration: 1.5 }}
          />
          <span>Server: Connected</span>
        </div>
        <div className="flex items-center space-x-2">
          <motion.div
            className="h-3 w-3 rounded-full bg-green-400"
            animate={{ scale: [1, 1.2, 1] }}
            transition={{ repeat: Infinity, duration: 1.5 }}
          />
          <span>Tracking: High Accuracy</span>
        </div>
      </div>
    );
  }
  export default StatusLights;